import { UserData } from '@/Support/Users/Interfaces/UserData'
import { PaginationLink } from '@/Support/Queries/Interfaces/PaginationLink'
import { PaginationMeta } from '@/Support/Queries/Interfaces/PaginationMeta'

export enum NotificationCategory {
  Success,
  Warning,
  Danger,
  Reminder,
  Neutral,
}

export interface SimpleNotificationData {
  title: string
  content: string
  system?: boolean
  category?: NotificationCategory
  hide?: boolean
}

export interface NotificationData extends SimpleNotificationData {
  id: string
  date: string
  owner?: UserData
  url?: string
  url_label_button?: string
  unread: boolean
  confirmation: boolean
  confirmation_label?: string | null
}

export interface NotificationsData {
  data: NotificationData[]
  link: PaginationLink[]
  meta: PaginationMeta
}

export interface NotificationBannerData {
  buttonTitle: string
}
